import { CalendarTwoIcon } from '@repo/ui/icons'

import UserNavBar from '../../components/elements/nav-bar'
import { CenterEventTable } from '../../components/pages/center-events/center-event-table'

type Props = {
  centerId?: number
}

export function CentersEventListPage({ centerId }: Props) {
  return (
    <div>
      <UserNavBar title={'Liste des évènements'} icon={CalendarTwoIcon} />
      <div className={'h-4'} />
      <CenterEventTable centerId={centerId} version={'FULL'} />
    </div>
  )
}
